export const i18nCht = {
  'login.title1': 'Hello',
  'login.title2': 'Sign in to manage your works on HKAA Community',
  'login.adfs': 'Login with ADFS',
  'login.login': '登入',
  'login.username': 'Username',
  'login.password': 'Password',

  'dashboard.title': 'Dashboard',

  'post.title': 'Post',
  'post.dashboard': 'Dashboard',
  'post.allPosts': 'All Posts',
  'post.addNew': 'Add New',

  'post_template.title': 'Post Template',
  'post_template.allPostTemplates': 'All Templates',
  'post_template.addNew': 'Add New',

  'notification.title': 'Notifications',

  'category.title': 'Categories',

  'user.title': 'User',
  'user.allUsers': 'All Users',
  'user.addNew': 'Add New',
  'user.userGroup': 'User Group',
  'user.roles': 'Roles'
}